import React, { useEffect, useMemo, useState } from 'react';
import { Box, Collapse, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { MdiIcon, Table, useSnackbar } from '@components';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DropzoneArea } from 'mui-file-dropzone';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { mdiChevronUp, mdiContentSave, mdiMagnify, mdiPlus } from '@mdi/js';
import moment from 'moment';
import { InfoDialog } from './infoDialog';
import { useModal } from 'mui-modal-provider';
import { v4 } from 'uuid';
import { DateTimePicker } from '@mui/x-date-pickers';
const Interacoes = ({ $state, CrmService, contacto, client, vendedor }) => {
    const [dataInteracoes, setDataInteracoes] = useState(); // dados dos clientes
    const [loadingInteracoes, setLoadingInteracoes] = useState(true);
    const [refetchingInteracoes, setRefetchingInteracoes] = useState(false);
    const [filterInteracoes, setFilterInteracoes] = useState([]); // filtros a aplicar na tabela
    const [sortInteracoes, setSortInteracoes] = useState([]); // ordenação da tabela
    const [contactos, setContactos] = useState([]);
    const [optionsInteracoes, setOptionsInteracoes] = useState({
        filter: [], // exemplo -> [{name: 'nome', type: 'TEXT'}, {name: 'ultimoContacto', type: 'DATE', options: {format: 'YYYY-MM-DD'}}, ...]
        sort: [] // exemplo -> ['id', 'nome', 'ultimoContacto', 'contactoTelefonico', 'nif', 'email', 'morada', 'localidade']
    });
    const [paginationInteracoes, setPaginationInteracoes] = useState({
        pageIndex: 0,
        pageSize: 5
    });
    const [expand, setExpand] = useState(false);
    const [disable, setDisable] = useState(false);
    const [anexo, setAnexo] = useState(null);
    const [newAnexo, setNewAnexo] = useState(null);
    const tipoList = ['Telefone', 'Mail', 'Pessoal', 'Mensagem'];
    const validationSchema = yup.object().shape({
        coreContactoId: yup.number().required('O campo é obrigatório'),
        dataInteracao: yup.string().required('O campo é obrigatório'),
        objetivos: yup.string().required('O campo é obrigatório').min(5, 'Os objetivos devem ter pelo menos 5 caracteres'),
        tipo: yup.string().required('O campo é obrigatório').min(3, 'O tipo deve ter pelo menos 3 caracteres')
    });
    const { showModal } = useModal();
    const { showSnackbar } = useSnackbar();
    const formik = useFormik({
        initialValues: {
            dataInteracao: moment()
        },
        validationSchema: validationSchema,
        validateOnChange: false,
        onSubmit: async (values) => {
            //console.log(values);
            submit({
                ...values,
                dataInteracao: moment(values.dataInteracao).format()
            });
        }
    });
    const submit = async (newValues) => {
        if (newValues.anexo) {
            handleFile(newValues);
        }
        try {
            if (contacto) {
                newValues.coreContactoId = contacto?.id;
                newValues.coreClienteId = contacto?.clienteId;
            }
            if (client) {
                newValues.coreClienteId = client;
            }
            const p = await CrmService.createInteracao(newValues);
            setRefetchingInteracoes(true);
            fetchData();
            setExpand(false);
            formik.resetForm();
            showSnackbar('Interação registada com sucesso');
        }
        catch (error) {
            console.log(error);
            showSnackbar('Ocorreu um erro ao registar interação');
        }
        setDisable(false);
    };
    const handleFile = async (values) => {
        const formData = new FormData();
        if (newAnexo.file) {
            const newFileName = values.anexo ? values.anexo : newAnexo.file.name;
            formData.append('file', newAnexo.file, newFileName);
            // Se a imagem for igual, não realiza upload
            if (newAnexo.dummy) {
                return values;
            }
            else {
                // Atualiza o valor da imagem no objeto `values`
                values.anexo = newFileName;
                try {
                    // Upload da nova imagem
                    const response = await fetch('/api/Upload/crm/upload', {
                        method: 'POST',
                        body: formData
                    });
                    if (response.ok) {
                        const content = await response.json();
                        return content.result;
                    }
                    else {
                        console.log(response);
                        console.error('Erro ao adicionar ficheiro');
                    }
                }
                catch (error) {
                    console.error('Error uploading file:', error);
                }
            }
        }
        else {
            return values;
        }
    };
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const baseColumns = useMemo(() => [
        {
            accessorKey: 'dataInteracao',
            header: 'Data',
            size: 100,
            Cell: ({ renderedCellValue }) => moment(renderedCellValue).format('DD/MM/YYYY HH:mm')
        },
        {
            accessorKey: 'tipo',
            header: 'Tipo',
            size: 100
        },
        {
            accessorKey: 'objetivos',
            header: 'Objetivos',
            size: 200
        }
    ], []);
    const dynamicColumns = useMemo(() => {
        let newColumns = [...baseColumns];
        if (contacto !== undefined) {
            newColumns = [
                {
                    accessorKey: 'Funcionario.name',
                    header: 'Registado por',
                    size: 100
                },
                ...newColumns
            ];
        }
        if (vendedor !== undefined) {
            newColumns = [
                {
                    accessorKey: 'CoreCliente.nome',
                    header: 'Cliente',
                    size: 100
                },
                {
                    accessorKey: 'CoreContacto.nome',
                    header: 'Contacto',
                    size: 100
                },
                ...newColumns
            ];
        }
        if (client !== undefined) {
            newColumns = [
                {
                    accessorKey: 'Funcionario.name',
                    header: 'Registado por',
                    size: 100
                },
                {
                    accessorKey: 'CoreContacto.nome',
                    header: 'Contacto',
                    size: 100
                },
                ...newColumns
            ];
        }
        return newColumns;
    }, [contacto, vendedor, client, baseColumns]); // Dependências
    const initialFetch = async () => {
        if (loadingInteracoes) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsInteracoes();
            setOptionsInteracoes(opt);
            setLoadingInteracoes(false);
        }
    };
    const loadContactos = async () => {
        const d = await CrmService.getContactosForCliente(client);
        setContactos(d);
    };
    useEffect(() => {
        if (client) {
            loadContactos();
        }
    }, [expand, client]);
    const fetchData = async () => {
        try {
            let filters = {};
            filterInteracoes.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sortInteracoes.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            if (client !== undefined) {
                filters['coreClienteId'] = `$eq:${client}`;
            }
            if (contacto !== undefined) {
                filters['coreContactoId'] = `$eq:${contacto.id}`;
                formik.setFieldValue('coreContactoId', contacto.id);
            }
            if (vendedor !== undefined) {
                filters['funcionarioId'] = `$eq:${vendedor}`;
            }
            // aux vai buscar os dados consoante os filtros
            // exemplo -> { limit: 0, page: 20, filter[{nome: '$ilike:Pedro' }, ...], sortBy:['ultimoContacto:ASC',...]}
            const aux = await CrmService.findAllInteracoes({
                limit: paginationInteracoes.pageSize,
                page: paginationInteracoes.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            // Update URL
            $state.go($state.current.name, {
                limit: paginationInteracoes.pageSize,
                page: paginationInteracoes.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filterInteracoes).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            setDataInteracoes(aux);
        }
        catch (e) {
            console.log(e);
        }
        setRefetchingInteracoes(false);
    };
    useEffect(() => {
        initialFetch();
    }, []);
    useEffect(() => {
        if (!refetchingInteracoes) {
            setRefetchingInteracoes(true);
            fetchData();
        }
    }, [paginationInteracoes, filterInteracoes, sortInteracoes]);
    return (<Box>
      <Stack direction='column'>
        <Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='center'>
          <Typography variant='h6' sx={{ color: 'black', mb: 1 }}>
            Últimas interações
          </Typography>
          {contacto !== undefined || client !== undefined ? (<Box>
              {expand ? (<Tooltip title={'Cancelar'}>
                  <IconButton color='primary' onClick={() => setExpand(!expand)}>
                    <MdiIcon path={mdiChevronUp} sx={{ color: '#1976D2' }}/>
                  </IconButton>
                </Tooltip>) : (<Box></Box>)}
              <Tooltip title={'Adicionar interação'}>
                <IconButton color='primary' disabled={disable} onClick={() => {
                if (expand) {
                    //setDisable(true);
                    formik.handleSubmit();
                }
                else {
                    formik.resetForm();
                    if (contacto) {
                        formik.setFieldValue('coreContactoId', contacto.id, true);
                    }
                    setExpand(!expand);
                    setAnexo(null);
                }
            }}>
                  <MdiIcon path={!expand ? mdiPlus : mdiContentSave} sx={{ color: '#1976D2' }}></MdiIcon>
                </IconButton>
              </Tooltip>
            </Box>) : (<></>)}
        </Stack>
      </Stack>

      <Collapse in={expand}>
        <Grid container spacing={2}>
          {/* Área da esquerda */}
          <Grid item xs={8}>
            <Grid container spacing={2}>
              {/* Linha 1: Data e Objetivos */}
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker value={formik.values.dataInteracao} onChange={value => {
            formik.setFieldValue('dataInteracao', value); // Atualiza o campo no Formik
        }} slotProps={{
            textField: {
                size: 'small',
                fullWidth: true,
                label: 'Data',
                required: true,
                helperText: formik.touched.dataInteracao && typeof formik.errors.dataInteracao === 'string' ? formik.errors.dataInteracao : '',
                error: Boolean(formik.touched.dataInteracao && formik.errors.dataInteracao)
            }
        }}/>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth id='objetivos' label='Objetivos' color='info' size='small' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.objetivos} error={formik.touched.objetivos && Boolean(formik.errors.objetivos)} helperText={formik.touched.objetivos && formik.errors.objetivos} required={true}/>
              </Grid>
              {client && (<Grid item xs={12}>
                  <FormControl fullWidth size='small' sx={{
                '& .MuiOutlinedInput-root': {
                    borderRadius: '4px'
                }
            }} error={formik.touched.coreContactoId && Boolean(formik.errors.coreContactoId)}>
                    <InputLabel id='demo-simple-select-label' color='info' required>
                      Contacto
                    </InputLabel>
                    <Select name='coreContactoId' label='Contacto' value={formik.values.tipo} onChange={formik.handleChange} onBlur={formik.handleBlur} color='info' error={formik.touched.coreContactoId && Boolean(formik.errors.coreContactoId)}>
                      {contactos.map((item, index) => (<MenuItem value={item.id} key={index}>
                          {item.nome}
                        </MenuItem>))}
                    </Select>
                    <FormHelperText>{formik.touched.coreContactoId ? formik.errors.coreContactoId || '' : ''}</FormHelperText>
                  </FormControl>
                </Grid>)}
              <Grid item xs={12}>
                <FormControl fullWidth size='small' sx={{
            '& .MuiOutlinedInput-root': {
                borderRadius: '4px'
            }
        }} error={formik.touched.tipo && Boolean(formik.errors.tipo)}>
                  <InputLabel id='demo-simple-select-label' color='info' required>
                    Tipo
                  </InputLabel>
                  <Select name='tipo' label='Tipo ' value={formik.values.tipo} onChange={formik.handleChange} onBlur={formik.handleBlur} color='info' error={formik.touched.tipo && Boolean(formik.errors.tipo)}>
                    {tipoList.map((item, index) => (<MenuItem value={item} key={index}>
                        {item}
                      </MenuItem>))}
                  </Select>
                  <FormHelperText>{formik.touched.tipo ? formik.errors.tipo || '' : ''}</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <TextField fullWidth id='observacoes' name='observacoes' label='Observações' color='info' size='small' multiline={true} rows={3} onChange={formik.handleChange} value={formik.values.observacoes} error={formik.touched.observacoes && Boolean(formik.errors.observacoes)} helperText={formik.touched.observacoes && formik.errors.observacoes}/>
              </Grid>
            </Grid>
          </Grid>

          {/* Área da direita: Dropzone */}
          <Grid item xs={4}>
            <DropzoneArea acceptedFiles={['image/jpeg', 'image/png', 'application/pdf']} filesLimit={1} initialFiles={anexo ? [anexo] : []} onChange={files => {
            if (files.length > 0) {
                let t = files.pop();
                let f = new File([t], `${v4()}.${t.name.split('.').pop()}`, { type: t.type });
                setNewAnexo({ file: f, dummy: false });
                setAnexo(URL.createObjectURL(f));
                formik.setFieldValue('anexo', f.name);
            }
            else {
                formik.setFieldValue('anexo', null);
                setNewAnexo(null);
                setAnexo(null);
            }
        }} 
    //onChange={files => handleFileChange(files, input.field)}
    //dropzoneText={input.dropzoneText || 'Arraste e solte o ficheiro aqui ou clique'}
    showFileNamesInPreview={true} showAlerts={false} useChipsForPreview={true} dropzoneText='Arraste e solte o documento aqui ou clique'/>
          </Grid>
        </Grid>
      </Collapse>

      <Box sx={{
            mt: 1,
            borderRadius: '15px',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
        <Table storageKey={$state.current.name} data={dataInteracoes} columns={dynamicColumns} initial={{
            sort: sortInteracoes,
            filter: filterInteracoes
        }} isLoading={refetchingInteracoes} options={optionsInteracoes} onPaginate={setPaginationInteracoes} onFilter={setFilterInteracoes} onSort={setSortInteracoes} rowActionSize={100} actionItems={({ row }) => [
            <Box key={`actions-${row.original.id}`} gap={1} sx={{
                    width: '100%', // Ocupa toda a largura da célula
                    height: '100%', // Ocupa toda a altura da célula
                    display: 'flex',
                    justifyContent: 'center', // Centra horizontalmente
                    alignItems: 'center' // Centra verticalmente
                }}>
              <Tooltip title={'Ver detalhes'} placement='top'>
                <IconButton color='secondary' onClick={() => {
                    const showData = [
                        { key: 'Data da interação', value: moment(row.original.dataInteracao).format('DD/MM/YYYY HH:mm') },
                        { key: 'Funcionário', value: row.original.Funcionario.name },
                        { key: 'Cliente', value: row.original.CoreCliente.nome },
                        { key: 'Contacto', value: row.original.CoreContacto.nome },
                        { key: 'Tipo', value: row.original.tipo },
                        { key: 'Objetivos', value: row.original.objetivos },
                        { key: 'Anexo', value: row.original.anexo },
                        { key: 'Observações', value: row.original.observacoes }
                    ];
                    showModal(InfoDialog, {
                        title: 'Detalhes interação',
                        data: showData
                    });
                }}>
                  <MdiIcon path={mdiMagnify} sx={{ color: '#1976D2' }}/>
                </IconButton>
              </Tooltip>
            </Box>
        ]}></Table>
      </Box>
    </Box>);
};
export default Interacoes;
